import { Eye } from "lucide-react";
import type { BehavioralObservation } from "@/lib/behavioralContinuity";

interface Props {
  observations: BehavioralObservation[];
}

/**
 * Quiet, archival surface for behavioral continuity observations.
 * No scores. No charts. No achievement energy.
 */
const BehavioralObservationCard = ({ observations }: Props) => {
  if (!observations.length) return null;

  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2">
        <Eye className="w-3 h-3 text-cyan/60" strokeWidth={1.5} />
        <p className="text-[10px] font-mono tracking-[0.28em] uppercase text-muted-foreground/70">
          Behavioral Observations
        </p>
      </div>

      <div className="rounded-xl border border-border/40 bg-card/40 backdrop-blur-sm overflow-hidden">
        {observations.map((obs, i) => (
          <div
            key={i}
            className={`px-5 py-4 ${
              i !== observations.length - 1 ? "border-b border-border/30" : ""
            }`}
          >
            <p className="text-[9px] font-mono tracking-[0.24em] uppercase text-cyan/55 mb-1.5">
              {obs.label}
            </p>
            <p className="text-sm text-foreground/85 leading-relaxed font-light">
              {obs.observation}
            </p>
            {obs.continuity && (
              <p className="text-[10px] font-mono text-muted-foreground/40 mt-2 tracking-wide">
                {obs.continuity}
              </p>
            )}
          </div>
        ))}
      </div>

      <p className="text-[9px] font-mono tracking-[0.22em] uppercase text-muted-foreground/35 px-1">
        Quietly noticed across your rehearsals · Not a score
      </p>
    </section>
  );
};

export default BehavioralObservationCard;
